export default __webpack_public_path__ + "static/media/Archival_Policy_2.380c41e0.pdf";